import React, { Component } from 'react';
import './index.scss';
import Grid from 'material-ui/Grid';

class Warning extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                {/*<div className='warningDiv'>*/}
                    {/*<h3 className='underline'>หมายเหตุ*</h3>*/}
                    {/*<ol className="warning" >*/}
                        {/*<li>ค่าความประหยัดคำนวณจากส่วนต่างระหว่างบ้านที่มีการใช้งานเครื่องใช้ไฟฟ้าเท่ากันที่ติดตั้งระบบโซลาร์เซลล์ และที่ไม่ได้ติดตั้ง ระบบโซลาร์เซลล์ และมีการใช้งานในช่วงเวลากลางวัน</li>*/}
                        {/*<li>ค่าไฟฟ้าที่ประหยัดได้คำนวณจากอัตรา FT ณ​ปัจจุบัน</li>*/}
                    {/*</ol>*/}
                {/*</div>*/}
                <div className='warningDiv2'>
                    <Grid container className='containerGrid' spacing={0} >
                        <Grid xs={1} sm={1} md={1} lg={1}></Grid>
                        <Grid xs={10} sm={10} md={10} lg={10}>
                            <h3 className='underline'>หมายเหตุ*</h3>
                            <ol className="warning" >
                                <li>ค่าความประหยัดคำนวณจากส่วนต่างระหว่างบ้านที่มีการใช้งานเครื่องใช้ไฟฟ้าเท่ากันที่ติดตั้งระบบโซลาร์เซลล์ และที่ไม่ได้ติดตั้ง ระบบโซลาร์เซลล์ และมีการใช้งานในช่วงเวลากลางวัน</li>
                                <li>ค่าไฟฟ้าที่ประหยัดได้คำนวณจากอัตรา FT ณ ​ปัจจุบัน</li>
                                <li>ราคาข้างต้นเป็นราคาสำหรับการติดตั้งโซลาร์ของ บริษัท เสนาดีเวลลอปเม้นท์ จำกัด (มหาชน)เท่านั้น</li>
                                <li>การคำนวณปริมาณหน่วยไฟฟ้าที่ผลิตได้ขั้นต่ำ/ปี ใช้สมมติฐานความเข้มแสงอาทิตย์สูงสุดที่ 4 ชั่วโมง/วัน</li>
                                <li>ระยะทางสายไฟและท่อร้อยสายไฟ กรณีเกินกว่าระยะทางที่กำหนดข้างต้นคิดราคา 200 บาท/เมตร</li>
                                <li>บริษัทฯขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อมูลทั้งหมด โดยมิต้องแจ้งให้ทราบล่วงหน้าและข้อมูลทั้งหมดในเอกสารฉบับนี้ เป็นเพียงแค่ประมาณการ ไม่ใช่คำรับประกัน โดยปริมาณหน่วยไฟฟ้าที่ผลิตได้ อาจแตกต่างกันไปตามสภาพแวดล้อมต่างๆ เช่น ภูมิอากาศ, มุมองศา, การถูกบดบัง, พื้นที่ติดตั้ง</li>
                            </ol>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default Warning;


// WEBPACK FOOTER //
// ./src/components/footer/warning.js